
import { petCategories } from '../../../mocks/petListings';

interface PetCategoryBarProps {
  selected: string;
  onSelect: (id: string) => void;
}

export default function PetCategoryBar({ selected, onSelect }: PetCategoryBarProps) {
  return (
    <section className="py-8 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap justify-center gap-3">
          {petCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => onSelect(cat.id)}
              className={`px-5 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer flex items-center gap-2 ${
                selected === cat.id
                  ? 'bg-gradient-to-r from-[#9B4C9A] to-[#FF9BC8] text-white shadow-lg scale-105'
                  : 'bg-white text-[#4A3B5C] hover:shadow-md hover:scale-105 border border-[#E6E0F5]'
              }`}
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              <i className={`${cat.icon} w-5 h-5 flex items-center justify-center`}></i>
              {cat.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
